import FontCommand from "@ckeditor/ckeditor5-font/src/fontcommand"
import { UNDERLINE_COLOR } from "./utils"

export default class UnderlineColorCommand extends FontCommand {
  constructor(editor) {
    super(editor, UNDERLINE_COLOR)
  }
}
